export default __webpack_public_path__ + "static/media/ZIKOLAND4.6df08a31.png";